import { isWednesday } from 'date-fns';
import { nextWednesday } from 'date-fns/nextWednesday';

export const WEDNESDAY_HOUR_EST_DEADLINE = 17;

export const getEstDateParts = (date: Date = new Date()) => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    weekday: 'short',
    hour12: false,
  });

  const parts = formatter.formatToParts(date);

  const year = parseInt(parts.find((p) => p.type === 'year')?.value ?? '0');
  const month = parseInt(parts.find((p) => p.type === 'month')?.value ?? '1');
  const day = parseInt(parts.find((p) => p.type === 'day')?.value ?? '1');
  const hour = parseInt(parts.find((p) => p.type === 'hour')?.value ?? '0');

  const estDate = new Date(year, month - 1, day);

  return { estDate, hour };
};

export const getScanDataWeekEndingDate = (fromDate = new Date()): Date => {
  const { estDate, hour } = getEstDateParts(fromDate);

  if (isWednesday(estDate) && hour < WEDNESDAY_HOUR_EST_DEADLINE) {
    return estDate;
  }

  return nextWednesday(estDate);
};
